/* XPOWER - Barra fija: mostrar al bajar, menu desplegable, buscador y carrito.
   La barra arranca compacta. Aqui se mide si el menu completo cabe a un lado
   SIN tocar el logo (que va centrado). Si no cabe, se queda el boton de menu. */
(function(){
  'use strict';

  var barra = document.getElementById('xpBarra');
  if(!barra) return;

  var visible = false;
  var disparo = 220;

  function compacta(){ return barra.classList.contains('xp-barra--compacta'); }

  (function(){
    var caja = barra.querySelector('[data-xp-inicio]');
    if(!caja) return;
    var texto = caja.querySelector('.xp-barra__texto');
    if(!texto) return;
    var img = document.querySelector('.header-logo-fix img') ||
              document.querySelector('.header-logo img') ||
              document.querySelector('.site-header img');
    if(!img || !img.getAttribute('src')) return;
    var n = document.createElement('img');
    n.src = img.getAttribute('src');
    n.alt = img.getAttribute('alt') || 'XPOWER';
    caja.replaceChild(n, texto);
    n.addEventListener('load', function(){ medir(); });
  })();

  function ancho(el, hueco){
    var w = 0, k = el.children;
    for(var i=0;i<k.length;i++){ w += k[i].offsetWidth; }
    if(hueco && k.length > 1){ w += hueco * (k.length - 1); }
    return w;
  }

  /* El logo va centrado, asi que cada lado solo puede usar la mitad de lo
     que sobra. Si el menu no cabe en esa mitad, se pasa a boton de menu. */
  function medir(){
    if(window.innerWidth < 1100){
      barra.classList.add('xp-barra--compacta');
      return;
    }
    cierraMenu();
    barra.classList.remove('xp-barra--compacta');

    var fila = barra.querySelector('.xp-barra__fila');
    var lista = barra.querySelector('.xp-barra__lista');
    var marca = barra.querySelector('.xp-barra__marca');
    var iconos = barra.querySelector('.xp-barra__iconos');
    if(!fila || !lista || !marca || !iconos){ return; }

    var util = fila.clientWidth - 32;
    var lado = lista.scrollWidth;
    var otro = ancho(iconos, 14);
    if(otro > lado){ lado = otro; }
    var necesita = (lado * 2) + ancho(marca, 0) + 28 + 22;
    if(necesita > util){ barra.classList.add('xp-barra--compacta'); }
  }

  function cierraTodo(menos){
    var abiertos = barra.querySelectorAll('.xp-barra__item.xpb-abierto');
    for(var i=0;i<abiertos.length;i++){
      if(abiertos[i] === menos) continue;
      abiertos[i].classList.remove('xpb-abierto');
      var e = abiertos[i].querySelector('[data-xp-padre]');
      if(e){ e.setAttribute('aria-expanded','false'); }
    }
  }

  function cierraMenu(){
    barra.classList.remove('xp-barra--menu');
    var b = barra.querySelector('[data-xp-menu]');
    if(b){ b.setAttribute('aria-expanded','false'); }
    cierraTodo(null);
  }

  function cierraBusca(){
    barra.classList.remove('xp-barra--busca');
    var b = barra.querySelector('[data-xp-buscar]');
    if(b){ b.setAttribute('aria-expanded','false'); }
  }

  var btnMenu = barra.querySelector('[data-xp-menu]');
  if(btnMenu){
    btnMenu.addEventListener('click', function(){
      if(barra.classList.contains('xp-barra--menu')){ cierraMenu(); return; }
      cierraBusca();
      barra.classList.add('xp-barra--menu');
      btnMenu.setAttribute('aria-expanded','true');
    });
  }

  var padres = barra.querySelectorAll('[data-xp-padre]');
  for(var i=0;i<padres.length;i++){
    (function(enlace){
      var item = enlace.parentNode;
      var soloAbre = enlace.hasAttribute('data-xp-solo-abre');
      enlace.addEventListener('click', function(ev){
        if(!compacta() && !soloAbre) return;
        ev.preventDefault();
        var abierto = item.classList.contains('xpb-abierto');
        cierraTodo(item);
        if(abierto){
          item.classList.remove('xpb-abierto');
          enlace.setAttribute('aria-expanded','false');
        } else {
          item.classList.add('xpb-abierto');
          enlace.setAttribute('aria-expanded','true');
        }
      });
    })(padres[i]);
  }

  var btnBusca = barra.querySelector('[data-xp-buscar]');
  var campo = barra.querySelector('[data-xp-campo]');
  if(btnBusca){
    btnBusca.addEventListener('click', function(){
      if(barra.classList.contains('xp-barra--busca')){ cierraBusca(); return; }
      cierraMenu();
      barra.classList.add('xp-barra--busca');
      btnBusca.setAttribute('aria-expanded','true');
      if(campo){ setTimeout(function(){ campo.focus(); }, 60); }
    });
  }
  var btnCerrar = barra.querySelector('[data-xp-cerrar-busca]');
  if(btnCerrar){ btnCerrar.addEventListener('click', cierraBusca); }

  var forma = barra.querySelector('.xp-barra__forma');
  if(forma){
    forma.addEventListener('submit', function(ev){
      var v = campo ? campo.value : '';
      var vacio = true;
      for(var k=0;k<v.length;k++){ if(v.charAt(k) > ' '){ vacio = false; break; } }
      if(vacio){ ev.preventDefault(); if(campo){ campo.focus(); } }
    });
  }

  var inicio = barra.querySelector('[data-xp-inicio]');
  if(inicio){
    inicio.addEventListener('click', function(ev){
      var aqui = window.location.pathname;
      if(aqui === '/' || aqui === inicio.getAttribute('href')){
        ev.preventDefault();
        cierraMenu(); cierraBusca();
        try{ window.scrollTo({top:0, behavior:'smooth'}); }
        catch(e){ window.scrollTo(0,0); }
      }
    });
  }

  document.addEventListener('click', function(ev){
    if(barra.contains(ev.target)) return;
    cierraMenu();
    cierraBusca();
  });
  document.addEventListener('keydown', function(ev){
    if(ev.key === 'Escape'){ cierraMenu(); cierraBusca(); }
  });

  function contar(){
    if(!window.fetch) return;
    fetch('/cart.js', {credentials:'same-origin', cache:'no-store'})
      .then(function(r){ return r.json(); })
      .then(function(c){
        var g = document.getElementById('xpBarraCuenta');
        if(!g) return;
        var n = c && c.item_count ? c.item_count : 0;
        g.textContent = n > 99 ? '99+' : String(n);
        g.className = n > 0 ? 'xp-barra__globo tiene' : 'xp-barra__globo';
      })
      .catch(function(){});
  }

  function calcular(){
    var cab = document.querySelector('.site-header');
    var alto = cab ? cab.offsetHeight : 0;
    disparo = alto > 60 ? alto : 220;
  }
  function revisar(){
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var debe = y > disparo;
    if(debe === visible) return;
    visible = debe;
    if(debe){ barra.classList.add('xp-barra--vis'); }
    else { barra.classList.remove('xp-barra--vis'); cierraMenu(); cierraBusca(); }
  }

  medir();
  calcular();
  revisar();
  contar();

  if(document.fonts && document.fonts.ready && document.fonts.ready.then){
    document.fonts.ready.then(function(){ medir(); });
  }
  window.addEventListener('load', function(){ medir(); calcular(); });
  window.addEventListener('scroll', revisar, {passive:true});

  var t = null;
  window.addEventListener('resize', function(){
    if(t){ clearTimeout(t); }
    t = setTimeout(function(){ calcular(); revisar(); medir(); }, 140);
  }, {passive:true});

  document.addEventListener('click', function(ev){
    var x = ev.target;
    if(!x || !x.closest) return;
    if(x.closest('[name=add], .add-to-cart, .btn-cart, .xp-cta, form[action*="/cart/add"] button')){
      setTimeout(contar, 700);
      setTimeout(contar, 1900);
    }
  }, true);
})();